<div class="edit-page-root-container staff-payroll-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(!permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="10" readonly>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Employee Name</mat-label>
                                    <input matInput formControlName="name" maxlength="50" readonly>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="input-box-start">
                               
                                 <mat-form-field class="category-name" >
                                <mat-label>Category</mat-label>
                                <input matInput formControlName="category_name" readonly>
                                
                            </mat-form-field>
                            </div>
                            <div class="input-box-middle">
                                <!-- <mat-form-field class="group-name" style="width: 100%;">
                                    <mat-label>Group Name</mat-label>
                                    <input matInput [value]="selectedGroupName" readonly>
                                </mat-form-field> -->
                                 <mat-form-field class="department-name" >
                                <mat-label>Department</mat-label>
                                <input matInput formControlName="department_name" readonly>
                            </mat-form-field>



                            </div>
                           <div class="input-box-end">
                              <mat-form-field class="payroll-code">
                                <mat-label>Payroll Code</mat-label>
                                <input matInput formControlName="payroll_code" >
                                <mat-error *ngIf="editForm.controls['payroll_code'].hasError('required')">
                                    Payroll Code is required
                                </mat-error>
                                <mat-error *ngIf="editForm.controls['payroll_code'].hasError('minlength') || editForm.controls['payroll_code'].hasError('maxlength')">
                                     must be exactly 7 characters long
                                </mat-error>
                            </mat-form-field>
                           </div>
                         
                        </div>
                        <div class="input-group">
                            <mat-checkbox formControlName="fixed_pay">
                                Fixed Pay
                            </mat-checkbox>
                        </div>
                          

                    </div>
                </div>
            </form>
        </div>
    </div>
</div>